import { render } from "./alpha.vue?vue&type=template&id=8165d416&scoped=true"
import script from "./alpha.vue?vue&type=script&lang=js"
export * from "./alpha.vue?vue&type=script&lang=js"

import "./alpha.vue?vue&type=style&index=0&id=8165d416&scoped=true&lang=css"

import exportComponent from "C:\\Users\\86134\\Desktop\\Web\\Item\\来画设计\\laiiva-web\\packages\\QColor\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8165d416"]])

export default __exports__